export const SETTING_OPTIONS = () => {
  return {
    flow: {
      key: "flow",
      options: {
        option1Text: "m³/h",
        option2Text: "m³/d",
        option3Text: "gpm",
      },
    },
    pressure: {
      key: "pressure",
      options: {
        option1Text: "bar",
        option2Text: "psig",
      },
    },
    feed_quality: {
      key: "feed_quality",
      options: {
        option1Text: "uS/cm",
        option2Text: "mg/L",
      },
    },
    flux: {
      key: "flux",
      options: {
        option1Text: "lmh",
        option2Text: "gfd",
      },
    },
    temperature: {
      key: "temperature",
      options: {
        option1Text: "C",
        option2Text: "F",
      },
    },
    permeate_quality: {
      key: "permeate_quality",
      options: {
        option1Text: "uS/cm",
        option2Text: "mg/L",
      },
    },
    volume: {
      key: "volume",
      options: {
        option1Text: "m³",
        option2Text: "kgal",
      },
    },
    mass: {
      key: "mass",
      options: {
        option1Text: "kg",
        option2Text: "lb",
      },
    },
    currency: {
      key: "currency",
      options: {
        option1Text: "USD",
        option2Text: "Yuan",
        option3Text:"Euro"
      },
    },
  };
};

export const Currency_Conversion_Mapping = {
  USD: 1,
  Yuan: 7.17,
};
export const Language_Currency_Mapping = {
  en: "USD",
  zh: "Yuan",
};
export const Default_Currency_Rate = {
  USD: 1,
  Yuan: 7.17,
};
